import React from "react";

const loading = () => <div className=""></div>;

interface LandingLayoutProps {
  children?: any;
}

const LandingLayout = (props: LandingLayoutProps) => {

  React.useEffect(() => {
    // Remover cualquier clase de autenticación que pueda interferir
    if (document.body) {
      document.body.classList.remove(
        "authentication-bg",
        "authentication-bg-pattern"
      );
      
      // Agregar clases específicas para landing si es necesario
      document.body.classList.add("landing-page");
    }

    return () => {
      if (document.body) {
        document.body.classList.remove("landing-page");
      }
    };
  }, []);

  const children = props["children"] || null;

  return (
    <React.Suspense fallback={loading()}>
      {children}
    </React.Suspense>
  );
};
export default LandingLayout;
